export default __webpack_public_path__ + "static/media/promocionAlarma3Mobile.8a6fad4a.png";